import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useAuthStore } from "store/authStore";
import useFetch from "hooks/useFetch";
import { Box, Typography } from "@mui/material";
import CustomButton from "./Button";

const VerificationCodeResendTimer = () => {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(45);
  const { unverifiedUserInfo } = useAuthStore();

  const { triggerFetch: resendVerifyCode } = useFetch({
    url: "auth/resend-verification-code",
    method: "POST",
    context: { no401Redirect: true },
  });

  useEffect(() => {
    if (seconds === 0) return;

    const timer = setInterval(() => {
      setSeconds((s) => s - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [seconds]);

  const handleResendCode = async () => {
    await resendVerifyCode({ userId: unverifiedUserInfo.userId });

    if (seconds === 0) {
      setSeconds(45);
    }
  };

  const formatted = `00:${String(seconds).padStart(2, "0")}`;

  return (
    <Box sx={{ textAlign: "center" }}>
      {seconds > 0 ? (
        <Typography variant="body2" color="textSecondary">
          {t("resendVerificationCode")}&nbsp;
          <Typography component="span" variant="body2" color="textSecondary">
            {formatted}
          </Typography>
        </Typography>
      ) : (
        <>
          <Typography variant="body2">{t("noVerifitionCode")}</Typography>
          <CustomButton
            type="button"
            width={"max-content"}
            height={40}
            textButton={t("resendCode")}
            customColor="#6D6777"
            customHoverColor="transparent"
            customBorderRadius="8px"
            customFontSize="16px"
            customTextTransform="none"
            onClick={handleResendCode}
          />
        </>
      )}
    </Box>
  );
};

export default VerificationCodeResendTimer;
